import { shopPrefix } from '../../config';
import { http } from '../axios';
import { UsageCondition } from '../../../models/Product';
import { SubscriptionPeriodType } from '../../../models/Article';
import { convertUsageConditionToUsageConditionDto } from '../../shared/utils/convertLineItemKey';

const url = `${shopPrefix}/v2/selectionlists/:selectionListId/products/:productId/remove`;

export const removeSingleProductFromList = ({
    selectionListId,
    productId,
    subscriptionPeriodType,
    usageCondition
}: {
    selectionListId: string;
    productId: string;
    subscriptionPeriodType?: SubscriptionPeriodType;
    usageCondition: UsageCondition | undefined;
    title: string;
}) => {
    return http.put(
        url,
        { usageCondition: convertUsageConditionToUsageConditionDto(usageCondition), subscriptionPeriodType },
        {
            pathParams: {
                selectionListId,
                productId
            }
        }
    );
};
